import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { changes, fields } from 'src/components/utils/fields'
import { useMediaQuery } from '@mui/material'
import { BufferService, LoadingContext, M_Button, M_Fieldset, M_Header, M_MessageBoard, M_ElementDrawer, NavigateContext } from 'src/M_Components'
import { LabelOutlined, Refresh } from '@mui/icons-material'


export const EquipmentStatusCrud = () => {
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const [data, setData] = useState({})
    const [open, setOpen] = useState(false)
    const [passedRow, setPassedRow] = useState({})
    const [operation, setOperation] = useState('')
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [leavingPage, setLeavingPage] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [editingId, setEditingId] = useState(null) 

    const equipmentStatusService = new BufferService('EquipmentStatus', 'secondary')

    const sessionKeys = ['operation', 'data', 'open', 'passedRow', 'leavingPage']

    const matches = useMediaQuery('(min-width:1800px)')
    const matches2 = useMediaQuery('(min-width:1700px)')
    const matches3 = useMediaQuery('(min-width:1490px)')
    const matches4 = useMediaQuery('(min-width:1450px)')
    const matches5 = useMediaQuery('(min-width:1420px)')
    const matches6 = useMediaQuery('(min-width:1380px)')
    const matches7 = useMediaQuery('(min-width:1280px)')
    const matches8 = useMediaQuery('(min-width:1230px)')
    const matches9 = useMediaQuery('(min-width:1190px)')
    const matches10 = useMediaQuery('(min-width:1150px)')
    const matches11 = useMediaQuery('(min-width:970px)')
    const matches12 = useMediaQuery('(min-width:930px)')
    const matches13 = useMediaQuery('(min-width:850px)')
    const matches14 = useMediaQuery('(min-width:870px)')
    const matches15 = useMediaQuery('(min-width:615px)')
    const matches16 = useMediaQuery('(min-width:440px)')



    const EquipmentStatusFields = [
        { display: t('Status'), required: true, type: 'text', code: 'status' },
        { display: t('Status')+' '+t('Name'), required: true, type: 'text', code: 'statusName'},

        { display: t('Status')+' '+t('Level')+' '+('1'), type: 'text', code: 'statusLevel1'},
        { display: t('Status')+' '+t('Level')+' '+('2'), type: 'text', code: 'statusLevel2'},

        { display: t('EquipmentStatus')+' '+('Comments'), code: 'eqStatusComments', type: 'textArea', fullWidth: true, },
    ]
    

    useEffect(() => {
        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))

            const editingEquipmentStatus = JSON.parse(sessionStorage.getItem('editingEquipmentStatus'))
            const operationType = sessionStorage.getItem('operationType')
            
            if (editingEquipmentStatus && (operationType === 'Edit' || operationType === 'Copy')) {
                editOrCopyEquipmentStatus(editingEquipmentStatus.Id, operationType === 'Copy')
                
                sessionStorage.removeItem('editingEquipmentStatus')
                sessionStorage.removeItem('operationType')
            } else if (operationType === 'Create') {
                setOperation('Create')
                sessionStorage.removeItem('operationType')
            }
        }
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [id, operation, data, leavingPage])

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return
        if (eval(value) instanceof String && eval(value) === '') return
        if (eval(value) instanceof Number && eval(value) === '') return

        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))
        const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`))
        const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`))
        const tempLP = JSON.parse(sessionStorage.getItem(`${sessionID}leavingPage`))

        if ((tempO && tempO !== '') || (tempD && Object.keys(tempD).length !== 0) || tempOS || (tempPR && Object.keys(tempD).length !== 0)) {

            setOperation(new String(tempO))
            setData(new Object(tempD))
            setOpen(tempOS)
            setPassedRow(tempPR)
            setLeavingPage(tempLP || false)
            ctx.setIsLoad(false)

            return
        }
        get()
    }

    const get = () => {
        ctx.setIsLoad(false)
    }

    const checkEquipmentStatusExists = async (code) => {
        if (!code) return false
        
        try {
            const response = await equipmentStatusService.filter(`?filter=Code eq '${code}'`)
            
            if (response.name === 'AxiosError' || !response.Items) {
                return false
            }
            
            const exactMatch = response.Items.find(item => item.Code === code)
            
            return !!exactMatch

        } catch (error) {
            console.error('Error checking equipment status:', error)
            return false
        }
    }

    const onSave = async () => {

        // Validations
        if (!data.status || !data.statusName) {
            ctx.toastMessages('error', '', t('Missing required fields'))
            return
        }

        if (!isEditMode || (isEditMode && data.status !== data._originalCode)) {
            ctx.setIsLoad(true)
            const exists = await checkEquipmentStatusExists(data.status)
            ctx.setIsLoad(false)
            
            if (exists) {
                ctx.toastMessages('error', '', `${t('EquipmentStatus')} ${data.status} ${t('already exists')}`)
                return
            }
        }
        
        const equipmentStatusData = {
            Code: data.status,
            Name: data.statusName,
            Level1: data.statusLevel1 || '',
            Level2: data.statusLevel2 || '',

            Comments: data.eqStatusComments || '',
        }
        
        ctx.setIsLoad(true)

        const savePromise = isEditMode && editingId 
            ? equipmentStatusService.update(editingId, equipmentStatusData)
            : equipmentStatusService.post(equipmentStatusData)
        
        savePromise.then(response => {
            ctx.setIsLoad(false)
            
            if (response.name === 'AxiosError') {
                handleError(response)
                return
            }
            
            // Success
            const successMessage = isEditMode ? t('EquipmentStatus') + t('updatedSucessfully') : t('EquipmentStatus') + t('savedSucessfully')
            ctx.toastMessages('success', '', successMessage)
            
            ctx2.closeTab(JSON.parse(id))
            
        }).catch(error => {
            ctx.setIsLoad(false)
            handleError(error)
        })
    }

    const editOrCopyEquipmentStatus = (equipmentStatusId, isCopy = false) => {
        ctx.setIsLoad(true)
        
        equipmentStatusService.getId(equipmentStatusId).then(response => {
            ctx.setIsLoad(false)
            
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', '', `${t('EquipmentStatus')} ${t('Failed to load')}`)
                return
            }
            
            // Mapper
            const equipmentStatusData = {
                status: isCopy ? '' : (response.Code?.toString() || ''),
                statusName: response.Name?.toString() || '',
                statusLevel1: response.Level1?.toString() || '',
                statusLevel2: response.Level2?.toString() || '',
                eqStatusComments: response.Comments?.toString() || '',
                
                _isCopy: isCopy,
                _originalId: isCopy ? equipmentStatusId : null
            }

            if (isCopy) {
                delete equipmentStatusData.Id
                delete equipmentStatusData.ExternalId
                delete equipmentStatusData.CreatedAt
                delete equipmentStatusData.UpdatedAt

                setIsEditMode(false)  
                setEditingId(null)        
                setOperation('Create')    
            } else {
                setIsEditMode(true)         
                setEditingId(equipmentStatusId) 
                setOperation('Edit')      
            }

            setData(equipmentStatusData)
        
        }).catch(error => {
            ctx.setIsLoad(false)
            console.error('Error loading equipment:', error)
            ctx.toastMessages('error', '', `${t('EquipmentStatus')} ${t('Failed to load')}`)
        })
    }

    const refreshEquipmentStatus = () => {
        ctx.setIsLoad(true)
        
        sessionKeys.forEach(key => {
            sessionStorage.removeItem(`${id}${key}`)
        })
        
        // Initial values
        setData({})
        setPassedRow({})
        setOpen(false)
        setOperation('')
        setLeavingPage(false)
        setIsEditMode(false)
        setEditingId(null) 
        
        get()
        
        ctx.setIsLoad(false)
        ctx.toastMessages('success', t('Form refreshed'), '')    
    }
    
    const handleError = (error) => {
        
        let errorMessage = t('Error saving')+' '+t('EquipmentStatus')
        if (Array.isArray(data)) {
            errorMessage = data.map(e => `${e.field}: ${e.message}`).join('\n')
        } else if (data?.errors) {
            errorMessage = Object.entries(data.errors)
                .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                .join('; ')
        } else if (data?.message) {
            errorMessage = data.field ? `${data.field}: ${data.message}` : data.message
        } else if (data?.detail) {
            errorMessage = data.detail
        } else if (data?.title) {
            errorMessage = data.title
        } else if (error.message) {
            errorMessage = error.message
        }

        ctx.toastMessages('error', '', errorMessage)
    }


    return (
        <div >
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Back")}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => { setLeavingPage(true) }}
                        />
                        <M_Button
                            tooltip={t("Refresh")}
                            icon={<Refresh />}
                            label={t("Refresh")}
                            onClick={() => refreshEquipmentStatus()}
                        />
                        <M_Button
                            tooltip={t("Save")}
                            icon={<i className="pi pi-save "></i>}
                            label={t("Save")}
                            onClick={() => onSave()}
                        />
                    </>
                }
            />
            <div style={{ margin: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns:'auto'}}>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><LabelOutlined  style={{ marginRight: '10px', scale: '1.3' }} /> {t("EquipmentStatus")}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches16 && 'auto' || !matches9 && 'auto auto' || 'auto auto auto auto', justifyContent: 'space-evenly' , gap: '20px'}}>
                                {EquipmentStatusFields.map((field, index) => {
                                    if (field.type === 'separator') {
                                        //New line
                                        return <div key={`separator-${index}`} style={{ gridColumn: '1 / -1', height: '0' }} />;
                                    }
                
                                    if (field.fullWidth) {
                                        return (
                                            <div key={index} style={{ gridColumn: '1 / -1', width: '100%', marginTop: '10px' }}>
                                                {fields(field, index, data, setData, false, null, '100%')}
                                            </div>
                                        );
                                    }
                                    return fields(field, index, data, setData, null, null)
                                })}
                            </div>
                        }
                    />
                </div>
                <div style={{ margin: '25px' }}></div>
            </div >
            <M_MessageBoard
                warning
                open={leavingPage}
                title={t("leavingPageTitle")}
                body={t("leavingPageBody")}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={() => { ctx2.closeTab(JSON.parse(id)); setLeavingPage(false) }} label={t("ButtonConfirm")} />
                    </span>
                }
            />
        </div >
    )
}